export default "/images/bae8a7ec32d279e2052891deb95d94f5.avif";